export const cellsParser = (data: any, colConfig: any, cell: any) => {
  let colConfigTemp: any = {};
  if (colConfig?.length) {
    colConfigTemp = colConfig.reduce((acc: any, curr: any) => {
      const { alias, ...rest } = curr;
      return { ...acc, [alias]: { ...rest, alias } };
    }, {});
  }
  return data.reduce((acc: any, row: any, rowIndex: number) => {
    const prop = Object.entries(row).reduce((acc: any, curr: any) => {
      const aliasToRead = Array.isArray(curr) ? curr[0] : curr.alias;
      const config = { ...colConfigTemp[aliasToRead as keyof typeof colConfigTemp], readOnly: cell?.isDisabled };

      const [key, val] = curr;
      const { alias = key, sourceTable } = config;
      const value = row[alias] || val;
      const cellKey = `${alias}${rowIndex + 1}`;

      const expr = config.expr ? config.expr.replace(/#/g, rowIndex + 1).replace(/@/g, cell?.columnLegend) : '';

      const regularCell = {
        ...config,
        value,
        alias,
        key: cellKey,
        insideLedger: true,
        rowNumber: rowIndex,
        expr,
      };
      // special cells for shares ledger in FundOwnership
      if (row?.acquisition_ref) {
        regularCell.acquisition_ref = row.acquisition_ref;
      }
      const purchaseDateCell = { ...regularCell, sourceTable };
      const soldSharesCell = { ...regularCell, value: row[alias] || null };

      const sourceTableMap = {
        purchased: purchaseDateCell,
        sold: soldSharesCell,
      };

      return {
        ...acc,
        [cellKey]: sourceTable ? sourceTableMap[sourceTable as keyof typeof sourceTableMap] : regularCell,
      };
    }, {});

    return { ...acc, ...prop };
  }, {});
};

export const reverseCellsParser = (rows: any, cells: any) =>
  rows.map((row: any, rowIndex: number) =>
    Object.entries(row).reduce(
      (acc: any, [key]: any) => ({
        ...acc,
        [key]: cells[`${key}${rowIndex + 1}`] ? cells[`${key}${rowIndex + 1}`].value : null,
      }),
      {}
    )
  );
